<template>
  <el-dialog
    v-model="localVisible"
    title="주문처리"
    width="80%"
    :close-on-click-modal="false"
    align-center
    @close="emitClose"
  >
    <div class="modal-body">
      <div class="left-form">
        <div class="paste-box">
          <div class="paste-box-title">상품정보 붙여넣기</div>
          <div
            class="paste-zone"
            tabindex="0"
            role="textbox"
            aria-label="상품정보 붙여넣기"
            @paste="handleHtmlPaste"
          >
            <div class="paste-zone-placeholder">
              여기에 붙여넣기 (Ctrl+V)\n
              붙여넣는 즉시 주문번호/상품정보가 자동으로 채워집니다.
            </div>
          </div>
        </div>
        <el-form :model="form" label-position="top">
          <el-form-item>
            <div class="option-grid shipping-option-grid">
              <div
                v-for="opt in shippingOptions"
                :key="opt.value"
                class="option-card shipping-option-card"
                :class="{ selected: form.shipBy === opt.value }"
                @click="form.shipBy = opt.value"
              >
                <div class="option-info">{{ opt.title }}</div>
              </div>
            </div>
          </el-form-item>

          <el-form-item label="물류센터 요청사항 (선택)">
            <el-input
              v-model="form.tosstossRequestNote"
              type="textarea"
              :rows="1"
              placeholder="요청사항을 입력하세요(중국어로 입력해주세요)"
            />
          </el-form-item>

          <el-form-item label="부가서비스">
            <el-row :gutter="8">
              <el-col :xs="24" :sm="24">
                <div class="option-grid">
                  <div
                    v-for="opt in ancillaryInspectionOptions"
                    :key="`${opt.groupKey}-${opt.value}`"
                    class="option-card"
                    :class="{ selected: isAncillarySelected(opt.groupKey, opt.value) }"
                    @click="handleAncillaryClick(opt.groupKey, opt.value)"
                  >
                    <div class="option-info">{{ opt.title }}</div>
                  </div>
                </div>
              </el-col>

              <el-col :xs="24" :sm="24">
                <div class="option-grid">
                  <div
                    v-for="opt in ancillarySecondRowOptions"
                    :key="`${opt.groupKey}-${opt.value}`"
                    class="option-card"
                    :class="{ selected: isAncillarySelected(opt.groupKey, opt.value) }"
                    @click="handleAncillaryClick(opt.groupKey, opt.value)"
                  >
                    <div class="option-info">{{ opt.title }}</div>
                  </div>
                </div>
              </el-col>

              <el-col :xs="24" :sm="24">
                <div class="option-grid">
                  <div
                    v-for="opt in ancillaryPackOptions"
                    :key="`${opt.groupKey}-${opt.value}`"
                    class="option-card"
                    :class="{ selected: isAncillarySelected(opt.groupKey, opt.value) }"
                    @click="handleAncillaryClick(opt.groupKey, opt.value)"
                  >
                    <div class="option-info">{{ opt.title }}</div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-form-item>

        </el-form>
      </div>

      <div class="right-orders">
        <div class="shop-order-field">
          <el-input v-model="form.shopOrderNumber" placeholder="주문번호" />
        </div>
        <div class="order-meta" v-if="orderMeta">
          <div class="order-meta-head">
            <el-tag :type="orderMeta.market === 'naver' ? 'success' : 'info'" effect="dark">
              {{ marketLabel(orderMeta.market) }}
            </el-tag>
            <div class="order-meta-text">
              <div class="title-row">
                <div class="title">{{ orderMeta.productName }}</div>
              </div>
              <div v-if="orderMeta.optionLines.length" class="option-lines">
                <div
                  v-for="(line, index) in orderMeta.optionLines"
                  :key="`quickstar-option-${index}`"
                  class="opt"
                >
                  {{ line }}
                </div>
              </div>
            </div>
          </div>
          <div class="summary-row summary-row-full">
            <div class="summary-inline-label">문자발송상품명 <span style="color: red;">*</span></div>
            <el-input class="summary-inline-input" v-model="orderSummaryName" placeholder="상품명" />
          </div>
          <div class="summary-row expected-settlement-row">
            <div class="summary-inline-label">정산예정금액</div>
            <el-input
              class="summary-inline-input"
              v-model.number="expectedSettlement"
              type="number"
              :min="0"
              placeholder="정산예정금액"
            />
          </div>
          <div class="order-meta-actions">
            <div class="order-links">
              <el-link v-if="orderMeta && orderMeta.marketProductUrl" :href="orderMeta.marketProductUrl" target="_blank" type="primary">상품링크</el-link>
              <el-link v-if="orderMeta && orderMeta.productUrl" :href="orderMeta.productUrl" target="_blank">원상품링크</el-link>
            </div>
            <el-button size="small" type="primary" @click="addProduct" :disabled="isSubmitting">상품 추가</el-button>
          </div>
        </div>

        <div class="product-list" v-if="products && products.length">
          <div class="product-card" v-for="(p, idx) in products" :key="p.key">
            <div class="product-head">
              <div class="title">
                상품 {{ idx + 1 }}
              </div>
              <div class="actions">
                <el-button v-if="products.length > 1" size="small" type="danger" plain @click="removeProduct(idx)" :disabled="isSubmitting">삭제</el-button>
              </div>
            </div>

            <div class="product-form">
              <div class="product-left">
                <div class="image-thumb" :class="{ filled: p.imgUrl && isValidImageUrl(p.imgUrl) }">
                  <img v-if="p.imgUrl && isValidImageUrl(p.imgUrl)" :src="p.imgUrl" alt="preview" referrerpolicy="no-referrer" />
                  <div v-else class="image-placeholder">
                    <div class="image-placeholder-title"><span style="color: red;">*</span> 이미지</div>
                  </div>
                </div>
              </div>

              <div class="product-right">
                <div class="field">
                  <label class="field-label"><span style="color: red;">*</span> 상품 이미지 URL</label>
                  <el-input v-model="p.imgUrl" placeholder="https://..." @blur="() => handleImageBlur(p)" />
                </div>

                <div class="field-row">
                  <div class="field">
                    <label class="field-label"><span style="color: red;">*</span> 상세 URL</label>
                    <el-input v-model="p.url" placeholder="https://..." />
                  </div>

                  <div class="field">
                    <label class="field-label"><span style="color: red;">*</span> 품목(HS)</label>
                    <el-select
                      v-model="p.hsSelectedKey"
                      style="width: 100%"
                      :filterable="true"
                      :remote="true"
                      reserve-keyword
                      :remote-method="(q) => remoteSearchHs(p, q)"
                      :loading="p.hsLoading"
                      placeholder="코드·설명·검색어"
                      @change="() => handleHsChange(p)"
                    >
                      <el-option
                        v-for="item in p.hsCandidates"
                        :key="item.uniqueKey"
                        :label="`${item.code} - ${item.pName || '품명없음'}`"
                        :value="item.uniqueKey"
                      />
                    </el-select>
                  </div>
                </div>

                <div class="field-row">
                  <div class="field">
                    <label class="field-label"><span style="color: red;">*</span> 단가(CNY,¥)</label>
                    <el-input v-model="p.cost" type="number" placeholder="0.0" @blur="() => normalizeCost(p)" />
                  </div>
                  <div class="field">
                    <label class="field-label"><span style="color: red;">*</span> 수량</label>
                    <el-input v-model.number="p.qty" type="number" placeholder="1" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="buyer-info" v-if="orderEdit">
          <div class="buyer-row"><span class="label">수령인</span><el-input class="value" v-model="orderEdit.name" placeholder="이름" /></div>
          <div class="buyer-row"><span class="label">연락처</span><el-input class="value" v-model="orderEdit.tel" placeholder="전화번호" /></div>
          <div class="buyer-row"><span class="label">통관번호</span><el-input class="value" v-model="orderEdit.individualCustomUniqueCode" placeholder="개인통관고유부호" /></div>
          <div class="buyer-row"><span class="label">우편번호</span><el-input class="value" v-model="orderEdit.zipCode" placeholder="우편번호" /></div>
          <div class="buyer-row"><span class="label">주소</span><el-input class="value" v-model="orderEdit.baseAddress" placeholder="기본 주소" /></div>
          <div class="buyer-row"><span class="label">상세</span><el-input class="value" v-model="orderEdit.detailedAddress" placeholder="상세 주소" /></div>
          <div class="buyer-row"><span class="label">메모</span><el-input class="value" v-model="orderEdit.shippingMemo" placeholder="배송 메모" /></div>
        </div>
      </div>
    </div>

    <template #footer>
      <span class="dialog-footer">
        <el-button @click="emitClose" :disabled="isSubmitting">취소</el-button>
        <el-button type="primary" @click="emitSubmit" :loading="isSubmitting" :disabled="isSubmitting">처리완료</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
import { ref, watch, computed } from 'vue';
import { ElMessage } from 'element-plus';
import hsCodeRows from '@/assets/hsCodeSetting2.json';

const HS_ROWS = Array.isArray(hsCodeRows) ? hsCodeRows : [];
const HS_SEARCH_LIMIT = 100;

export default {
  name: 'QuickstarsProcessModal',
  props: {
    visible: { type: Boolean, default: false },
    order: { type: Object, default: () => null },
    defaultRequestNote: { type: String, default: '' },
    submitting: { type: Boolean, default: false }
  },
  emits: ['close', 'submit'],
  setup(props, { emit }) {
    const localVisible = ref(props.visible);

    const ANC_INBOUND_INSPECTION = [178, 180];
    const ANC_INBOUND_PIG = [182, 240];

    const ancillaryInbound = [
      { value: 178, title: '기본검수' },
      { value: 180, title: '무검수' },
      { value: 182, title: '돼지코(일반)' },
      { value: 240, title: '돼지코(고급)' },
    ];

    const ancillarySmallPack = [
      { value: 213, title: '뽁뽁이 삽입(소형)' },
      { value: 214, title: '안전봉투포장' },
    ];

    const ancillaryLargePack = [
      { value: 221, title: '뽁뽁이 삽입(대형)' },
    ];

    const shippingOptions = [
      { value: 38, title: '해운 자가' },
      { value: 37, title: '해운 평택' },
    ];

    const sanitizeAncillaryServices = (services = {}) => {
      const inboundAllowed = new Set(ancillaryInbound.map(opt => opt.value));
      const smallPackagingAllowed = new Set(ancillarySmallPack.map(opt => opt.value));
      const largePackagingAllowed = new Set(ancillaryLargePack.map(opt => opt.value));

      return {
        inbound: (Array.isArray(services.inbound) ? services.inbound : []).filter(value => inboundAllowed.has(value)),
        outbound: [],
        smallPackaging: (Array.isArray(services.smallPackaging) ? services.smallPackaging : []).filter(value => smallPackagingAllowed.has(value)),
        largePackaging: (Array.isArray(services.largePackaging) ? services.largePackaging : []).filter(value => largePackagingAllowed.has(value)),
      };
    };

    const ancillaryInspectionOptions = ancillaryInbound
      .filter(opt => ANC_INBOUND_INSPECTION.includes(opt.value))
      .map(opt => ({ ...opt, groupKey: 'inbound' }));

    const ancillarySecondRowOptions = ancillaryInbound
      .filter(opt => ANC_INBOUND_PIG.includes(opt.value))
      .map(opt => ({ ...opt, groupKey: 'inbound' }));

    const ancillaryPackOptions = [
      ...ancillarySmallPack.map(opt => ({ ...opt, groupKey: 'smallPackaging' })),
      ...ancillaryLargePack.map(opt => ({ ...opt, groupKey: 'largePackaging' })),
    ];

    const createDefaultForm = (defaultRequestNote = '') => ({
      shipBy: 38,
      shopOrderNumber: '',
      tosstossRequestNote: defaultRequestNote,
      ancillaryServices: {
        inbound: [178],
        outbound: [],
        smallPackaging: [],
        largePackaging: [],
      },
    });

    const form = ref(createDefaultForm(props.defaultRequestNote));

    const resetForm = (defaultRequestNote = '') => {
      form.value = createDefaultForm(defaultRequestNote);
    };

    // "모달 기본 상품 1개"는 qty 기본값(1) 때문에 완전 공란 판정이 어려움.
    // 붙여넣기 최초 1회에서는 url/img/cost/hs가 비어있으면 placeholder로 보고 교체한다.
    const isPlaceholderProductItem = (p) => {
      if (!p) return true;
      const hasUrl = !!String(p.url || '').trim();
      const hasImg = !!String(p.imgUrl || '').trim();
      const hasCost = !!String(p.cost || '').trim();
      const hasHs = !!String(p.hsSelectedKey || '').trim() || !!String(p.hsCode || '').trim();
      return !(hasUrl || hasImg || hasCost || hasHs);
    };

    const getOrderItems = (order) => {
      return Array.isArray(order?.items) ? order.items : [];
    };

    const formatOrderItemLine = (item) => {
      const optionText = String(item?.productOption || '옵션없음').trim();
      const qty = Number(item?.quantity);
      const qtyText = Number.isNaN(qty) || qty <= 0 ? '-' : qty;
      return `${optionText} x ${qtyText}`;
    };

    const getDefaultProductQty = (order) => {
      const items = getOrderItems(order);
      if (items.length !== 1) return 1;
      const qty = Number(items[0]?.quantity);
      return Number.isNaN(qty) || qty <= 0 ? 1 : qty;
    };

    const getDefaultSummaryName = (order) => {
      if (!order) return '';
      return String(order.productName || '').trim();
    };

    const applyParsed = (orderNo, parsedProducts) => {
      if (orderNo) form.value.shopOrderNumber = orderNo;
      if (!Array.isArray(parsedProducts) || parsedProducts.length === 0) return;

      const incoming = parsedProducts.map((pp) => {
        const base = createProductItem();
        if (!base.url) base.url = pp.url || '';
        base.imgUrl = pp.imgUrl || '';
        if (pp.price !== null) {
          const rounded = Math.round(Number(pp.price) * 10) / 10;
          base.cost = Number.isNaN(rounded) ? '' : rounded.toFixed(1);
        }
        if (pp.qty !== null) base.qty = pp.qty;
        return base;
      });

      const current = Array.isArray(products.value) ? products.value : [];
      const shouldReplace = current.length === 0 || (current.length === 1 && isPlaceholderProductItem(current[0]));
      products.value = shouldReplace ? incoming : [...current, ...incoming];

      if (!orderSummaryName.value || !String(orderSummaryName.value).trim()) {
        orderSummaryName.value = getDefaultSummaryName(props.order);
      }
    };

    const handleHtmlPaste = async (e) => {
      const html = e?.clipboardData?.getData('text/html');
      const plain = e?.clipboardData?.getData('text/plain');
      const dataToInsert = (html && String(html).trim()) ? html : (plain || '');
      if (!dataToInsert) return;

      // 붙여넣기 데이터가 "주문/상품 HTML"로 파싱되는 경우에만 기본 paste를 막고 자동입력 처리
      try {
        const orderNo = extractOrderNumberFromHtml(dataToInsert);
        const parsedProducts = extractProductsFromHtml(dataToInsert);
        const canApply = !!orderNo || (Array.isArray(parsedProducts) && parsedProducts.length > 0);
        if (!canApply) return;

        e.preventDefault();
        applyParsed(orderNo, parsedProducts);
      } catch (err) {
        // 파싱 실패 시에는 기본 paste를 막지 않음(붙여넣기 "안됨" 체감 방지)
        // 다만 paste-zone은 contenteditable이 아니라 기본 paste가 UI에 남지 않을 수 있으므로 메시지는 노출
        ElMessage.warning('붙여넣기 파싱에 실패했습니다. (다른 형식으로 복사했는지 확인)');
      }
    };

    const extractOrderNumberFromHtml = (htmlString) => {
      const raw = String(htmlString || '');
      if (!raw.trim()) return '';

      // 0순위: 1688/기타에서 orderId=123... 형태로 포함되는 케이스
      const orderIdParam = raw.match(/\borderId=(\d{10,})\b/);
      if (orderIdParam) return orderIdParam[1];

      // 1순위: '订单号' 라벨 옆에 있는 숫자(예: 3119...)
      try {
        const doc = new DOMParser().parseFromString(raw, 'text/html');
        const spans = Array.from(doc.querySelectorAll('span'));
        for (const s of spans) {
          const t = (s.textContent || '').trim();
          if (t !== '订单号') continue;

          // 같은 부모 영역에서 다음 span들 중 숫자 찾기
          const parent = s.parentElement || s;
          const candidates = Array.from(parent.querySelectorAll('span'));
          const idx = candidates.indexOf(s);
          const searchList = idx >= 0 ? candidates.slice(idx + 1) : candidates;
          for (const c of searchList) {
            const m = (c.textContent || '').trim().match(/^(\d{10,})$/);
            if (m) return m[1];
          }

          // 형제 노드로도 탐색
          let cur = s.nextElementSibling;
          while (cur) {
            const m = (cur.textContent || '').trim().match(/^(\d{10,})$/);
            if (m) return m[1];
            cur = cur.nextElementSibling;
          }
        }
      } catch (_) { /* no-op */ }

      // 2순위: 텍스트 기반 '订单号: 123...' 패턴 (HTML이 깨져도 대응)
      const orderId = raw.match(/订单号[\s\S]{0,40}?(\d{10,})/);
      if (orderId) return orderId[1];

      // 3순위: JT로 시작하는 번호 (케이스에 따라 송장/내부번호일 수 있음)
      const jt = raw.match(/\bJT\d{6,}\b/);
      if (jt) return jt[0];

      return '';
    };

    const extractCurrencyValues = (text) => {
      const t = String(text || '');
      const out = [];
      const re = /[￥¥]\s*([0-9]+(?:\.[0-9]+)?)/g;
      let m;
      while ((m = re.exec(t))) {
        const n = Number(m[1]);
        if (!Number.isNaN(n)) out.push(n);
      }
      return out;
    };

    const pickMinPositive = (nums) => {
      const list = Array.isArray(nums) ? nums.filter(n => typeof n === 'number' && n > 0) : [];
      if (list.length === 0) return null;
      return Math.min(...list);
    };

    const parseCssBackgroundImageUrl = (styleText) => {
      const s = String(styleText || '');
      if (!s) return '';
      const m = s.match(/background-image\s*:\s*url\(\s*["']?([^"')]+)["']?\s*\)/i);
      return m ? String(m[1] || '').trim() : '';
    };

    const removeShippingNodes = (rootEl) => {
      if (!rootEl || !rootEl.querySelectorAll) return;
      const shippingKeywords = ['运费', '含运费'];
      const nodes = Array.from(rootEl.querySelectorAll('*'));
      for (const el of nodes) {
        const text = (el.textContent || '').trim();
        if (!text) continue;
        if (shippingKeywords.some(k => text.includes(k))) {
          try { el.remove(); } catch (_) { /* no-op */ }
        }
      }
    };

    const extractUnitPriceFromRow = (tr) => {
      try {
        // 주문목록형(test2.html)에서 단가 셀은 strong 없이 (del + 현재가) 형태가 많음
        const priceBoxes = Array.from(tr.querySelectorAll('div.price-mod__price___3Un7c'));
        const unitBox = priceBoxes.find(el => !el.querySelector('strong'));
        if (unitBox) {
          const nums = extractCurrencyValues(unitBox.textContent || '');
          const v = pickMinPositive(nums);
          if (typeof v === 'number' && !Number.isNaN(v) && v > 0) return v;
        }

        // fallback: 행 전체에서 배송비(运费) 관련 노드 제거 후 최소값
        const cloned = tr.cloneNode(true);
        removeShippingNodes(cloned);
        const rowText = cloned.textContent || '';
        const rowPrices = extractCurrencyValues(rowText);
        return pickMinPositive(rowPrices);
      } catch (_) {
        return null;
      }
    };

    const extractTotalPaidFromRow = (tr) => {
      try {
        // 목록형(test2.html)에서는 결제총액이 strong로 강조되어 있음 (배송비 0이어도 여기 값이 목표)
        const strongNums = Array.from(tr.querySelectorAll('strong'))
          .flatMap(s => extractCurrencyValues(s.textContent || ''))
          .filter(n => typeof n === 'number' && !Number.isNaN(n) && n > 0);
        if (strongNums.length) return Math.max(...strongNums);
      } catch (_) { /* no-op */ }
      return null;
    };

    const extractFinalPaidAmountFromDoc = (doc) => {
      try {
        // 0순위(신버전): "实付款" 라벨이 포함된 가격 컨테이너에서만 정확히 추출
        // (주문 전체 컨테이너처럼 큰 div를 잡으면 상품가/원가까지 섞여 max가 튈 수 있음)
        const priceContainers = Array.from(doc.querySelectorAll('.trade-price-container,[class*="trade-price-container"]'));
        for (const el of priceContainers) {
          const labelEl = el.querySelector('.trade-price-label,[class*="trade-price-label"]');
          const labelText = (labelEl?.textContent || el.textContent || '').trim();
          if (!labelText) continue;
          if (!labelText.includes('实付款') && !labelText.includes('实付')) continue;
          const nums = extractCurrencyValues(el.textContent || '').filter(n => n > 0);
          if (nums.length) return Math.max(...nums);
        }

        const keywords = ['实付款', '实付', '订单金额', '合计', '总计', '付款'];
        const nodes = Array.from(doc.querySelectorAll('strong,b,td,span,p,div'));
        for (const node of nodes) {
          const text = (node.textContent || '').trim();
          if (!text) continue;
          if (!keywords.some(k => text.includes(k))) continue;
          // 너무 큰 컨테이너(div)에 걸리면 상품가/원가가 같이 포함될 수 있어 과대값이 나올 수 있음
          // (예: "实付款" + "￥421" + "￥547" 같이 섞이면 max가 547로 튐)
          if (text.length > 240) continue;
          const nums = extractCurrencyValues(text).filter(n => n > 0);
          if (nums.length) return Math.max(...nums);
        }

        // fallback: 전체 문서에서 마지막 통화값
        const all = extractCurrencyValues(doc.body?.textContent || '').filter(n => n > 0);
        if (all.length) return all[all.length - 1];
      } catch (_) { /* no-op */ }
      return null;
    };

    const extractProductsFromNewTaobaoHtml = (doc) => {
      try {
        // 신버전은 상품 1개가 하나의 itemInfo 블록으로 구성됨:
        // <div class="itemInfo--... trade-bought-list-order-info">
        //   <div class="itemInfoColItem--..."> ... (a[href*=item.taobao.com], background-image) ...</div>
        //   <div class="itemInfoColPrice--..."> ... (￥가격, x수량) ...</div>
        // </div>
        const itemBlocks = Array.from(doc.querySelectorAll('.trade-bought-list-order-info,[class*="trade-bought-list-order-info"]'));
        if (!itemBlocks.length) return [];

        const out = [];

        for (const block of itemBlocks) {
          const a = block.querySelector('a[href*="item.taobao.com/item.htm"]');
          const href = a?.getAttribute('href') || '';
          if (!href) continue;
          const url = href.startsWith('http') ? href : (href.startsWith('//') ? `https:${href}` : `https://${href.replace(/^\/+/, '')}`);

          // 이미지: 신버전은 background-image로 들어오는 경우가 대부분
          let imgUrlRaw = parseCssBackgroundImageUrl(a?.getAttribute('style'));
          if (!imgUrlRaw) {
            const bg = block.querySelector('[style*="background-image"]');
            imgUrlRaw = parseCssBackgroundImageUrl(bg?.getAttribute('style'));
          }
          const imgUrl = normalizeTaobaoImageUrl(imgUrlRaw);

          // 단가: itemInfoColPrice 안에서 '实付款/运费' 제외, 최소 양수값(할인가 우선)
          let price = null;
          const priceCol = block.querySelector('[class*="itemInfoColPrice"]') || block;
          const priceText = (priceCol.textContent || '').trim();
          if (priceText && !priceText.includes('实付款') && !priceText.includes('含运费') && !priceText.includes('运费')) {
            price = pickMinPositive(extractCurrencyValues(priceText));
          }

          // 수량: x1, x2...
          let qty = null;
          const qtyEl = priceCol.querySelector('[class*="quantity"]');
          const m = (qtyEl?.textContent || priceText || '').match(/\bx\s*(\d{1,3})\b/i);
          if (m) qty = Number(m[1]);

          out.push({
            url,
            imgUrl,
            price: (typeof price === 'number' && !Number.isNaN(price)) ? price : null,
            qty: (typeof qty === 'number' && !Number.isNaN(qty) && qty > 0) ? qty : null,
          });
        }

        // 총 수량이 1이면: 쿠폰/배송비까지 반영된 실付款을 단가로 사용(기존 정책 유지)
        const totalQty = out.reduce((sum, p) => sum + (typeof p.qty === 'number' && p.qty > 0 ? p.qty : 1), 0);
        if (totalQty === 1 && out.length >= 1) {
          const paid = extractFinalPaidAmountFromDoc(doc);
          if (typeof paid === 'number' && !Number.isNaN(paid) && paid > 0) {
            out[0].price = paid;
          }
        }

        return out;
      } catch (_) {
        return [];
      }
    };

    const getQueryRootsIncludingTemplates = (root) => {
      const roots = [];
      if (!root) return roots;
      roots.push(root);
      try {
        const templates = Array.from(root.querySelectorAll?.('template') || []);
        for (const t of templates) {
          if (t?.content) roots.push(t.content);
        }
      } catch (_) { /* no-op */ }
      return roots;
    };

    const queryFirstFromRoots = (roots, selector) => {
      const list = Array.isArray(roots) ? roots : [];
      for (const r of list) {
        try {
          const el = r?.querySelector?.(selector);
          if (el) return el;
        } catch (_) { /* no-op */ }
      }
      return null;
    };

    const extractProductsFrom1688Html = (doc) => {
      try {
        const entries = Array.from(doc.querySelectorAll('.order-item-entry'));
        if (!entries.length) return [];

        // 주문 단위 총액(含运费 반영된 금액) - 보통 상품 1개 주문일 때 이 값을 cost로 쓰고 싶음
        let orderTotal = null;
        try {
          const roots = getQueryRootsIncludingTemplates(doc);
          const totalEl = queryFirstFromRoots(roots, 'order-item-total-price .total-price') || queryFirstFromRoots(roots, '.total-price');
          if (totalEl) {
            orderTotal = pickMinPositive(extractCurrencyValues(totalEl.textContent || ''));
          }
        } catch (_) { /* no-op */ }

        const out = [];

        for (const entry of entries) {
          const roots = getQueryRootsIncludingTemplates(entry);

          // 상품 URL: 1688 offer 링크
          const a =
            queryFirstFromRoots(roots, 'a.product-img[href*="detail.1688.com/offer/"]') ||
            queryFirstFromRoots(roots, 'a.product-name[href*="detail.1688.com/offer/"]') ||
            queryFirstFromRoots(roots, 'a[href*="detail.1688.com/offer/"]');

          const href = a?.getAttribute?.('href') || '';
          if (!href) continue;
          const url = href.startsWith('http') ? href : (href.startsWith('//') ? `https:${href}` : `https://${href.replace(/^\/+/, '')}`);

          // 이미지: 상품 이미지 우선
          const imgEl =
            queryFirstFromRoots(roots, 'a.product-img img[src]') ||
            queryFirstFromRoots(roots, 'img[src*="alicdn.com"]') ||
            queryFirstFromRoots(roots, 'img[src]');
          const imgUrl = normalizeTaobaoImageUrl(imgEl?.getAttribute?.('src') || '');

          // 단가: actual-unit-price 텍스트에서 추출
          let price = null;
          const unitPriceEl = queryFirstFromRoots(roots, '.actual-unit-price');
          if (unitPriceEl) {
            price = pickMinPositive(extractCurrencyValues(unitPriceEl.textContent || ''));
          }

          // 수량: quantity-amount
          let qty = null;
          const qtyEl = queryFirstFromRoots(roots, '.quantity-amount');
          if (qtyEl) {
            const n = Number(String(qtyEl.textContent || '').trim());
            if (!Number.isNaN(n) && n > 0) qty = n;
          }

          out.push({
            url,
            imgUrl,
            price: (typeof price === 'number' && !Number.isNaN(price)) ? price : null,
            qty: (typeof qty === 'number' && !Number.isNaN(qty)) ? qty : null,
          });
        }

        // 1688에서는 "총액(total-price)"가 단가보다 실구매원가로 더 유용한 경우가 많음
        // - 상품 1개(또는 총 수량 1)인 경우: 총액을 cost로 사용
        // - 단가를 못 찾았으면(템플릿이 비거나 구조가 달라서): 총액으로 보정
        const totalQty = out.reduce((sum, p) => sum + (typeof p.qty === 'number' && p.qty > 0 ? p.qty : 1), 0);
        if (typeof orderTotal === 'number' && !Number.isNaN(orderTotal) && orderTotal > 0 && out.length >= 1) {
          if (totalQty === 1) {
            out[0].price = orderTotal;
          } else {
            out.forEach((p) => {
              if (p.price === null) p.price = orderTotal;
            });
          }
        }

        return out;
      } catch (_) {
        return [];
      }
    };

    const extractProductsFromHtml = (htmlString) => {
      const html = String(htmlString || '');
      if (!html.trim()) return [];

      let doc;
      try {
        doc = new DOMParser().parseFromString(html, 'text/html');
      } catch (_) {
        return [];
      }
      if (!doc) return [];

      const rows = Array.from(doc.querySelectorAll('tr'));
      const products = [];
      let firstProductTr = null;

      for (const tr of rows) {
        const link = tr.querySelector('a[href*="item.taobao.com/item.htm"]');
        if (!link) continue;

        const href = link.getAttribute('href') || '';
        if (!href) continue;
        const url = href.startsWith('http') ? href : (href.startsWith('//') ? `https:${href}` : `https://${href.replace(/^\/+/, '')}`);

        const img = tr.querySelector('img[src]');
        const imgUrlRaw = img?.getAttribute('src') || '';
        const imgUrl = normalizeTaobaoImageUrl(imgUrlRaw);

        // row 내 통화값 후보들: 상품가/배송비/총액이 섞일 수 있어 단가 영역을 우선 추출
        const price = extractUnitPriceFromRow(tr); // (상품 2개 이상일 때) 판매자 할인가를 우선하기 위해 최소값 사용

        // 수량: 가격 셀 다음 td를 먼저 보고, 없으면 숫자-only td에서 추정(1~999)
        const tds = Array.from(tr.querySelectorAll('td'));
        const priceTdIndex = tds.findIndex(td => /[￥¥]\s*\d/.test(td.textContent || ''));
        let qty = null;
        if (priceTdIndex >= 0 && tds[priceTdIndex + 1]) {
          const m = (tds[priceTdIndex + 1].textContent || '').match(/\b(\d{1,3})\b/);
          if (m) qty = Number(m[1]);
        }
        if (qty === null) {
          const digitOnlyCandidates = tds
            .map(td => (td.textContent || '').trim())
            .map(t => (/^\d{1,3}$/.test(t) ? Number(t) : null))
            .filter(n => typeof n === 'number' && !Number.isNaN(n) && n >= 1 && n <= 999);
          if (digitOnlyCandidates.length) qty = digitOnlyCandidates[0];
        }

        products.push({
          url,
          imgUrl,
          price: (typeof price === 'number' && !Number.isNaN(price)) ? price : null,
          qty: (typeof qty === 'number' && !Number.isNaN(qty)) ? qty : null,
        });

        if (!firstProductTr) firstProductTr = tr;
      }

      // 신버전(목록/상세 div 기반) fallback: tr이 없거나 파싱 실패 시
      if (products.length === 0) {
        const fromNew = extractProductsFromNewTaobaoHtml(doc);
        if (Array.isArray(fromNew) && fromNew.length) return fromNew;
      }

      // 1688 주문목록(커스텀 엘리먼트 + shadowroot template) fallback
      if (products.length === 0) {
        const from1688 = extractProductsFrom1688Html(doc);
        if (Array.isArray(from1688) && from1688.length) return from1688;
      }

      // "상품이 1개" 판단은 row 개수뿐 아니라 수량 합계를 기준으로
      // - 총 수량이 1이면: 쿠폰까지 적용된 최종 결제금액(실付款)을 cost로 사용
      // - 총 수량이 2 이상이면: (쿠폰이 주문 전체에 분산되므로) row 내 판매자 할인가(최소값) 유지
      const totalQty = products.reduce((sum, p) => sum + (typeof p.qty === 'number' && p.qty > 0 ? p.qty : 1), 0);
      if (totalQty === 1 && products.length >= 1) {
        // 1순위: 주문목록형(test2.html)에서 strong로 표시되는 결제총액
        const paidFromRow = firstProductTr ? extractTotalPaidFromRow(firstProductTr) : null;
        // 2순위: 문서 전체에서 키워드(实付款 등) 기반으로 결제금액 탐색
        const paid = (typeof paidFromRow === 'number' && paidFromRow > 0) ? paidFromRow : extractFinalPaidAmountFromDoc(doc);
        if (typeof paid === 'number' && !Number.isNaN(paid) && paid > 0) {
          // 총 수량 1인 경우에만 paid를 그대로 사용
          products[0].price = paid;
        }
      }

      return products;
    };

    const isSubmitting = computed(() => props.submitting);

    const products = ref([]);
    const orderEdit = ref(null);
    const orderSummaryName = ref('');
    const expectedSettlement = ref(0);
    const warnedProductCountMismatchSignature = ref('');

    const getDefaultExpectedSettlement = (order) => {
      if (!order) return 0;
      const sales = Number(order.sales);
      return Number.isNaN(sales) ? 0 : sales;
    };

    const orderMeta = computed(() => {
      const o = props.order;
      if (!o) return null;
      return {
        market: o.market,
        productName: o.productName,
        optionLines: getOrderItems(o).map(formatOrderItemLine),
        productUrl: o.productUrl || '',
        marketProductUrl: o.marketProductUrl || '',
        sales: Number.isNaN(Number(o.sales)) ? 0 : Number(o.sales),
      };
    });

    const marketLabel = (market) => {
      if (market === 'naver') return '네이버';
      return '기타';
    };

    const createProductItem = () => ({
      key: `${Date.now()}-${Math.random().toString(16).slice(2)}`,
      url: '',
      imgUrl: '',
      qty: 1,
      cost: '',
      hsCode: '',
      hsSelectedKey: '',
      hsNameEn: '',
      hsCandidates: [],
      hsLoading: false
    });

    const buildProducts = () => {
      const o = props.order;
      if (!o) {
        products.value = [];
        orderEdit.value = null;
        orderSummaryName.value = '';
        expectedSettlement.value = 0;
        warnedProductCountMismatchSignature.value = '';
        return;
      }
      products.value = [createProductItem()];
      products.value[0].qty = getDefaultProductQty(o);

      orderSummaryName.value = getDefaultSummaryName(o);
      expectedSettlement.value = getDefaultExpectedSettlement(o);
      warnedProductCountMismatchSignature.value = '';

      orderEdit.value = {
        name: o.shippingInfo?.recipientName || '',
        tel: o.shippingInfo?.recipientTel || '',
        zipCode: o.shippingInfo?.zipCode || '',
        baseAddress: o.shippingInfo?.baseAddress || '',
        detailedAddress: o.shippingInfo?.detailedAddress || '',
        shippingMemo: o.shippingInfo?.shippingMemo || '',
        individualCustomUniqueCode: o.individualCustomUniqueCode || ''
      };
    };

    const addProduct = () => {
      const o = props.order;
      if (!o) return;
      const row = createProductItem();
      products.value.push(row);
      warnedProductCountMismatchSignature.value = '';
    };

    const removeProduct = (idx) => {
      if (!Array.isArray(products.value)) return;
      if (products.value.length <= 1) return;
      products.value.splice(idx, 1);
      warnedProductCountMismatchSignature.value = '';
    };

    watch(() => props.order, () => buildProducts(), { immediate: true });

    watch(() => props.visible, (visible) => {
      localVisible.value = visible;
      if (visible) {
        resetForm(props.defaultRequestNote);
        buildProducts();
      }
    });

    // 모달 열릴 때 이후 로직이 필요하면 여기에 추가하세요 (현재 불필요하여 제거)

    const remoteSearchHs = (p, query) => {
      if (!p) return;
      const raw = String(query || '').trim();
      if (!raw) {
        p.hsCandidates = [];
        return;
      }
      const q = raw.toLowerCase();
      p.hsLoading = true;
      try {
        const list = [];
        for (let i = 0; i < HS_ROWS.length && list.length < HS_SEARCH_LIMIT; i += 1) {
          const row = HS_ROWS[i];
          const codeStr = String(row.code);
          const blob = [codeStr, row.searchText, row.nameEn]
            .filter((x) => x != null && String(x).trim() !== '')
            .map((x) => String(x).toLowerCase())
            .join(' ');
          if (blob.includes(q)) {
            list.push({
              code: codeStr,
              pName: row.searchText || '',
              pNameEn: row.nameEn || '',
              uniqueKey: `${row.code}::${row.searchText || ''}`,
            });
          }
        }
        p.hsCandidates = list;
      } finally {
        p.hsLoading = false;
      }
    };

    const handleHsChange = (p) => {
      if (!p) return;
      const selected = p.hsCandidates.find(c => c.uniqueKey === p.hsSelectedKey);
      if (!selected) return;
      p.hsCode = selected.code || '';
      p.hsNameEn = selected.pNameEn || '';
    };

    const toggleInArray = (arr, value) => {
      const i = arr.indexOf(value);
      if (i > -1) arr.splice(i, 1);
      else arr.push(value);
    };

    const handleAncillaryClick = (groupKey, value) => {
      const a = form.value.ancillaryServices;
      const list = a[groupKey];
      if (!Array.isArray(list)) return;

      if (groupKey === 'inbound') {
        const has = list.includes(value);
        if (ANC_INBOUND_INSPECTION.includes(value)) {
          if (has) {
            const next = list.filter((v) => !ANC_INBOUND_INSPECTION.includes(v));
            a.inbound = next.length ? next : [178];
          } else {
            a.inbound = [...list.filter((v) => !ANC_INBOUND_INSPECTION.includes(v)), value];
          }
          return;
        }
        if (ANC_INBOUND_PIG.includes(value)) {
          if (has) {
            a.inbound = list.filter((v) => v !== value);
          } else {
            a.inbound = [...list.filter((v) => !ANC_INBOUND_PIG.includes(v)), value];
          }
          return;
        }
        toggleInArray(list, value);
        return;
      }

      if (groupKey === 'smallPackaging') {
        if (list.includes(value)) {
          a.smallPackaging = list.filter((v) => v !== value);
        } else {
          a.smallPackaging = [...list, value];
          a.largePackaging = [];
        }
        return;
      }

      if (groupKey === 'largePackaging') {
        if (list.includes(value)) {
          a.largePackaging = [];
        } else {
          a.largePackaging = [value];
          a.smallPackaging = [];
        }
      }
    };

    const isAncillarySelected = (groupKey, value) => {
      const list = form.value?.ancillaryServices?.[groupKey];
      return Array.isArray(list) ? list.includes(value) : false;
    };

    const emitClose = () => emit('close');

    const isValidImageUrl = (url) => {
      if (!url) return false;
      try {
        const candidate = String(url).startsWith('//') ? `https:${url}` : url;
        const u = new URL(candidate);
        const okProto = u.protocol === 'http:' || u.protocol === 'https:';
        const okExt = /(\.(png|jpe?g|gif|webp|bmp|svg)(\?.*)?$)/i.test(u.pathname);
        return okProto && (okExt || !!u.search);
      } catch (_) {
        return false;
      }
    };

    const normalizeTaobaoImageUrl = (url) => {
      let u = String(url || '').trim();
      if (!u) return '';
      if (u.startsWith('//')) u = `https:${u}`;
      // taobao/1688 이미지 URL 정리:
      // - ex) ...jpg_80x80.jpg              => ...jpg
      // - ex) ...cib.jpg_160x160.jpg_.webp  => ...cib.jpg  (요청사항: "첫번째 .jpg까지")
      try {
        const parsed = new URL(u);
        const m = String(parsed.pathname || '').match(/^(.*?\.(?:jpe?g|png|gif|webp|bmp|svg))/i);
        if (m && m[1]) {
          parsed.pathname = m[1];
          return parsed.toString();
        }
        return u;
      } catch (_) {
        const [base, query] = u.split('?');
        const m = String(base || '').match(/^(.*?\.(?:jpe?g|png|gif|webp|bmp|svg))/i);
        const cleaned = (m && m[1]) ? m[1] : base;
        return query ? `${cleaned}?${query}` : cleaned;
      }
    };

    function normalizeCost(p) {
      if (!p) return;
      const n = Number(p.cost);
      if (Number.isNaN(n)) return;
      const rounded = Math.round(n * 10) / 10; // 소수점 2번째 자리에서 반올림
      p.cost = rounded.toFixed(1); // 1자리까지 표기
    }

    const handleImageBlur = (p) => {
      if (!p) return;
      if (p.imgUrl && !isValidImageUrl(p.imgUrl)) {
        ElMessage.warning('유효한 이미지 URL을 입력하세요.');
        return;
      }
      if (p.imgUrl) p.imgUrl = normalizeTaobaoImageUrl(p.imgUrl);
    };

    const emitSubmit = async () => {
      if (isSubmitting.value) return; // 이미 처리 중이면 중복 실행 방지
      
      // 간단 유효성 체크
      if (!orderMeta.value || !orderEdit.value) {
        ElMessage.warning('처리할 주문이 없습니다.');
        return;
      }
      if (!orderSummaryName.value || !String(orderSummaryName.value).trim()) {
        ElMessage.warning('문자발송상품명을 입력해주세요.');
        return;
      }
      if (!String(orderEdit.value.name || '').trim()) {
        ElMessage.warning('수령인 이름을 입력해주세요.');
        return;
      }
      if (!String(orderEdit.value.tel || '').trim()) {
        ElMessage.warning('수령인 연락처를 입력해주세요.');
        return;
      }

      const list = Array.isArray(products.value) ? products.value : [];
      if (list.length === 0) {
        ElMessage.warning('등록할 상품이 없습니다. 상품을 추가해주세요.');
        return;
      }

      for (let i = 0; i < list.length; i += 1) {
        const p = list[i];
        const prefix = `상품 ${i + 1}: `;
        normalizeCost(p);
        if (!p.cost || Number(p.cost) <= 0 || !p.qty || Number(p.qty) <= 0) {
          ElMessage.warning(prefix + '원가와 수량을 입력해주세요.');
          return;
        }
        if (!p.hsSelectedKey || !p.hsCode) {
          ElMessage.warning(prefix + 'HS Code를 선택해주세요.');
          return;
        }
        if (!String(p.hsNameEn || '').trim()) {
          ElMessage.warning(prefix + 'HS 상품 영문명이 필요합니다. HS Code를 다시 선택해주세요.');
          return;
        }
        if (!p.imgUrl) {
          ElMessage.warning(prefix + '이미지 URL을 입력해주세요.');
          return;
        }
        if (!p.url) {
          ElMessage.warning(prefix + '구매 사이트 URL을 입력해주세요.');
          return;
        }
        if (!isValidImageUrl(p.imgUrl)) {
          ElMessage.warning(prefix + '유효한 이미지 URL을 입력하세요.');
          return;
        }
      }
      
      try {
        const o = props.order;
        const optionCount = getOrderItems(o).length;
        const productCount = list.length;
        const mismatchSignature = `${optionCount}:${productCount}`;
        if (optionCount > 0 && productCount < optionCount) {
          if (warnedProductCountMismatchSignature.value !== mismatchSignature) {
            warnedProductCountMismatchSignature.value = mismatchSignature;
            ElMessage.warning(`주문 옵션은 ${optionCount}개인데 등록 상품은 ${productCount}개입니다. 한 번 더 누르면 그대로 처리됩니다.`);
            return;
          }
        } else {
          warnedProductCountMismatchSignature.value = '';
        }

        const settlementInput = Number(expectedSettlement.value);
        if (Number.isNaN(settlementInput) || settlementInput < 0) {
          ElMessage.warning('정산예정금액을 0 이상의 숫자로 입력해주세요.');
          return;
        }

        const quickstarItems = list.map((p) => ({
          productName: String(p.hsNameEn || '').trim(),
          cost: Number(p.cost),
          qty: Number(p.qty),
          url: p.url,
          imgUrl: normalizeTaobaoImageUrl(p.imgUrl),
          hsCode: p.hsCode || '',
        }));

        const totalCost = quickstarItems.reduce((sum, p) => sum + (Number(p.cost) * Number(p.qty)), 0);

        const ancillaryServices = sanitizeAncillaryServices(form.value.ancillaryServices);

        const payload = {
          market: {
            name: o.market,
            marketNumber: o.marketNumber || null,
            sellerProductCode: o.sellerProductCode || null,
            productOrderIds: Array.isArray(o.productOrderIds) ? o.productOrderIds : [],
          },
          recipient: {
            name: String(orderEdit.value.name || '').trim(),
            tel: String(orderEdit.value.tel || '').trim(),
            zipCode: String(orderEdit.value.zipCode || '').trim(),
            baseAddress: String(orderEdit.value.baseAddress || '').trim(),
            detailedAddress: String(orderEdit.value.detailedAddress || '').trim(),
            shippingMemo: String(orderEdit.value.shippingMemo || '').trim(),
            individualCustomUniqueCode: String(orderEdit.value.individualCustomUniqueCode || '').trim(),
          },
          quickstarItems,
          settlement: {
            summaryName: String(orderSummaryName.value).trim(),
            inflowPath: (o.market === 'naver') ? (o.inflowPath || null) : null,
            expectedSettlement: settlementInput,
            totalCost
          },
          quickstar: {
            shipBy: form.value.shipBy,
            ancillaryServices,
            shopOrderNumber: String(form.value.shopOrderNumber || '').trim() || null,
            requestNote: String(form.value.tosstossRequestNote || '').trim() || null,
          }
        };
        
        emit('submit', payload);
      } catch (error) {
        ElMessage.error('처리 중 오류가 발생했습니다.');
        console.error('Submit error:', error);
      }
    };

    return {
      localVisible,
      form,
      shippingOptions,
      products,
      orderEdit,
      orderMeta,
      orderSummaryName,
      expectedSettlement,
      marketLabel,
      remoteSearchHs,
      handleHsChange,
      ancillaryInspectionOptions,
      ancillarySecondRowOptions,
      ancillaryPackOptions,
      handleAncillaryClick,
      isAncillarySelected,
      emitClose,
      emitSubmit,
      normalizeCost,
      handleImageBlur,
      handleHtmlPaste,
      addProduct,
      removeProduct,
      isValidImageUrl,
      isSubmitting
    };
  }
}
</script>

<style scoped>
.modal-body {
  display: grid;
  grid-template-columns: 1fr 1.6fr;
  gap: var(--spacing-md);
  min-height: 520px;
  position: relative;
}

.modal-body::before {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  width: 1px;
  background: var(--el-border-color-lighter);
  left: calc(((100% - var(--spacing-md)) / 2.6) + (var(--spacing-md) / 2));
  pointer-events: none;
}

.left-form {
  background: var(--el-bg-color);
  border-radius: var(--el-border-radius-base);
  padding: var(--spacing-sm) var(--spacing-md);
}

.paste-box {
  margin-bottom: var(--spacing-md);
  padding-bottom: var(--spacing-sm);
  border-bottom: 1px dashed var(--el-border-color-lighter);
}

.paste-box-title {
  font-size: 12px;
  color: var(--el-text-color-secondary);
  margin-bottom: 6px;
  font-weight: var(--el-font-weight-medium);
}

.paste-zone {
  height: 96px;
  max-height: 96px;
  border: 1px solid var(--el-border-color-lighter);
  border-radius: 12px;
  padding: 10px;
  background: var(--el-bg-color);
  outline: none;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: text;
}

.paste-zone:focus {
  border-color: var(--el-color-primary);
}

.paste-zone-placeholder {
  white-space: pre-line;
  text-align: center;
  color: var(--el-text-color-placeholder);
  line-height: 1.35;
  font-size: 12px;
  user-select: none;
}

.right-orders {
  background: var(--el-bg-color);
  border-radius: var(--el-border-radius-base);
  padding: var(--spacing-md);
  overflow: auto;
}

.shop-order-field { margin-bottom: var(--spacing-sm); }

.product-list {
  display: flex;
  gap: var(--spacing-sm);
  overflow-x: auto;
  overflow-y: hidden;
  padding-top: 8px;
  padding-bottom: 8px;
}

.order-meta {
  border: 1px solid var(--el-border-color-lighter);
  border-radius: var(--el-border-radius-base);
  padding: var(--spacing-sm);
  margin-bottom: var(--spacing-sm);

}

.order-meta-head {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
}

.order-meta-text {
  min-width: 0;
  flex: 1;
}

.title-row {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.order-meta-head .title {
  font-weight: var(--el-font-weight-medium);
  font-size: var(--el-font-size-base);
}

.option-lines {
  margin-top: 8px;
}

.option-lines .opt {
  color: var(--el-text-color-secondary);
  font-size: 13px;
  line-height: 1.5;
  font-weight: var(--el-font-weight-medium);
}

.order-meta-actions {
  margin-top: 8px;
  display: flex;
  justify-content: space-between;
  gap: 10px;
  align-items: center;
}

.order-links {
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.summary-row {
  margin-top: 8px;
  display: flex;
  gap: 10px;
  align-items: center;
}

.summary-inline-label {
  flex: 0 0 120px;
  width: 120px;
  font-size: 12px;
  color: var(--el-text-color-secondary);
  white-space: nowrap;
}

.summary-inline-input {
  flex: 0 1 360px;
  width: 100%;
  max-width: 360px;
  min-width: 220px;
}

.summary-row-full .summary-inline-input {
  flex: 1 1 auto;
  max-width: none;
  min-width: 0;
}

.product-card {
  border: 1px solid var(--el-border-color-lighter);
  border-radius: 18px;
  padding: 10px;
  min-width: 520px;
  flex: 0 0 520px;
  background: var(--el-bg-color);
  transition: transform .15s ease, border-color .15s ease, background-color .15s ease;
}

.product-card:hover {
  transform: translateY(-1px);
  border-color: var(--el-color-primary);
}

.product-head {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  margin-bottom: 8px;
  justify-content: space-between;
}

.product-head .actions {
  display: flex;
  gap: 6px;
}

.product-head .title {
  font-weight: var(--el-font-weight-medium);
  font-size: var(--el-font-size-base);
}

/* 카드형 상품 입력 UI */
.product-form {
  display: grid;
  grid-template-columns: 170px 1fr;
  gap: 10px;
  align-items: start;
}

.product-left,
.product-right {
  display: grid;
  gap: 8px;
}

.image-thumb {
  width: 100%;
  height: 170px;
  border-radius: 12px;
  border: 1px solid var(--el-border-color-lighter);
  background: var(--el-fill-color-lighter);
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}

.image-thumb img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: #fff;
}

.image-placeholder {
  color: var(--el-text-color-secondary);
  font-size: 13px;
  text-align: center;
}

.image-placeholder-title {
  font-weight: var(--el-font-weight-medium);
}

.field { display: grid; gap: 4px; }
.field-label { font-size: 12px; color: var(--el-text-color-secondary); }

.field-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  align-items: end;
}



.buyer-info {
  margin-top: var(--spacing-sm);
  border-top: 1px dashed var(--el-border-color-lighter);
  padding-top: var(--spacing-sm);
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 6px 10px;
}
.buyer-row { display: flex; gap: 8px; align-items: flex-start; margin-bottom: 0; }
.buyer-row .label {
  width: 64px;
  flex: 0 0 64px;
  color: var(--el-text-color-secondary);
  font-size: 12px;
}
.buyer-row .value { color: var(--el-text-color-primary); font-size: 12px; }

.option-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 6px;
  border: 1px solid var(--el-border-color-lighter);
  border-radius: 4px;
  padding: 6px;
  background: var(--el-fill-color-light);
}

.shipping-option-grid {
  grid-template-columns: repeat(2, 1fr);
  width: calc((((100% - 24px) / 3) * 2) + 6px);
  max-width: 100%;
}

.option-card {
  border: 1px solid var(--el-border-color-lighter);
  border-radius: 4px;
  padding: 8px 6px;
  cursor: pointer;
  transition: all 0.15s ease;
  background: white;
  text-align: center;
  min-height: 68px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.option-card:hover {
  border-color: var(--el-color-primary);
  transform: translateY(-1px);
}

.option-card.selected {
  border-color: var(--el-color-primary);
  background: var(--el-color-primary);
  color: white;
}

.option-card.selected .option-info {
  color: white;
}

.option-info {
  font-size: 13px;
  color: var(--el-text-color-primary);
  margin: 1px 0;
  line-height: 1.2;
  text-align: center;
}

@media (max-width: 1024px) {
  .modal-body { grid-template-columns: 1fr; }
  .modal-body::before { display: none; }
  .option-grid { grid-template-columns: repeat(2, 1fr); }
  .shipping-option-grid { width: 100%; }
  .buyer-info { grid-template-columns: 1fr; }
  .summary-inline-input {
    flex: 1 1 auto;
    max-width: none;
    min-width: 0;
  }
}
</style>


